/**
 * formatPhone — normalize any phone entry to the US 3-3-4 cadence
 * (XXX-XXX-XXXX), applied uniformly across every phone field in the app.
 *
 * Format-as-you-type: keep only digits, tolerate a leading US country code
 * ('1'), cap at 10 digits, and insert the dashes progressively so the field
 * reads 555, 555-123, 555-123-4567 as the user types. Idempotent — re-running
 * on an already-formatted value returns the same string.
 */
export function formatPhone(raw: string | null | undefined): string {
  let d = (raw ?? '').replace(/\D/g, '');
  if (d.length === 11 && d[0] === '1') d = d.slice(1); // drop a leading US country code
  d = d.slice(0, 10);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}-${d.slice(3)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
}
